import {assertAndContinue} from 'Asserts';
import {getApolloClient} from 'graphql-client/ApolloClient';
import documentStore from 'notebook/documents/DocumentStore';
import {FETCH_PENDING_TABLE_ROWS_QUERY} from 'notebook/structured-tables/queries/FETCH_PENDING_TABLE_ROWS_QUERY';
import {hasNLO, isStructuredTable} from 'notebook/TypePredicates';
import {AnyStructuredTable, Note} from 'notebook/util/NoteUtilConstants';
import notifications from 'notifications';
import {RealtimeMessageType} from 'realtime/Constants';
// @ts-expect-error
import entryStore from 'stores/EntryStore';
import APIUtil from 'util/APIUtil';

import type {DocumentUpdateMessageHandler} from './DocumentUpdateMessageHandlerConstants';

export const tableApiPendingRowsUpdateMessageHandler: DocumentUpdateMessageHandler<
  typeof RealtimeMessageType.TABLE_API_PENDING_ROWS_UPDATE
> = {
  active: (fileId, {structuredTableApiId}) => {
    getApolloClient().refetchQueries({include: [FETCH_PENDING_TABLE_ROWS_QUERY]});

    if (structuredTableApiId == null) {
      assertAndContinue(
        false,
        `Structured Table API ID was not found in realtime message: ${RealtimeMessageType.TABLE_API_PENDING_ROWS_UPDATE}`
      );
      return;
    }

    const note = getNoteByFileId(fileId);
    if (note == null) {
      assertAndContinue(false, `Note was not found in store for fileId: ${fileId}`);
      return;
    }

    const structuredTable = getStructuredTableByApiId(note, structuredTableApiId);
    if (structuredTable == null) {
      assertAndContinue(
        false,
        `Structured table with apiId: ${structuredTableApiId} was not found in note for fileId: ${fileId}`
      );
      return;
    }

    notifications.success(`Table '${structuredTable.name}' has new pending API rows.`);
  },
};

function getNoteByFileId(fileId: string): Note | null {
  const Store = APIUtil.isEntry(fileId) ? entryStore : APIUtil.isDocument(fileId) ? documentStore : null;
  if (Store == null) {
    return null;
  }
  if (!Store.inStore(fileId)) {
    return null;
  }
  return Store.getNote(fileId);
}

function getStructuredTableByApiId(note: Note, structuredTableApiId: string): AnyStructuredTable | null {
  for (const part of note.noteParts) {
    if (!hasNLO(part)) {
      continue;
    }
    if (!isStructuredTable(part.item)) {
      continue;
    }
    if (part.item.apiId === structuredTableApiId) {
      return part.item;
    }
  }
  return null;
}
